import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Constants } from '../../_utility';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-home-prenotazioni',
  templateUrl: './home-prenotazioni.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule],
})
export class HomePrenotazioniComponent implements OnInit {
  constructor(private router: Router, private breadcrumb: BreadcrumbsService) {}

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.HOME_PRENOTAZIONI.path);
    }, 200);
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'extraction': {
        this.router.navigate(Constants.Routing.EXTRACTION.routerLink);
        break;
      }
      case 'administration': {
        this.router.navigate(Constants.Routing.ADMINISTRATION.routerLink);
        break;
      }
    }
  }
}
